<template>
    <div
      class="board"
     
    >
      <div class="sks"><span @click="gos">
          ＜ </span>
          <div class="timg" style="width: 30%;position: absolute; top: 0.5rem; left: 0.8rem;">
            <img src="../../../assets/jvip/01.png" alt="">

          </div>
          <div class="serch" style="width: 60%;position: absolute; top: 0rem;right: 0.2rem;">
            <van-search shape="round" background="#640fb2" v-model="value" placeholder="请输入搜索关键词" />
          </div>
      </div>
      <div style="height: 0.2rem;"></div>
      <van-swipe :autoplay="3000">
        <van-swipe-item>
          <img
            src="../../../assets/jvip/02.jpg"
            alt=""
          >
        </van-swipe-item>
        <van-swipe-item>
          <img
            src="../../../assets/jvip/03.jpg"
            alt=""
          >
        </van-swipe-item><van-swipe-item>
          <img
            src="../../../assets/jvip/04.jpg"
            alt=""
          >
        </van-swipe-item><van-swipe-item>
          <img
            src="../../../assets/jvip/05.jpg"
            alt=""
          >
        </van-swipe-item>
        <van-swipe-item>
          <img
            src="../../../assets/jvip/06.jpg"
            alt=""
          >
        </van-swipe-item>
      </van-swipe>
     <div class="guod">
     
      <!-- <img src="../../assets/s11/ss/02-1.png" alt=""> -->
     </div>
     <img src="../../../assets/you/01.png" alt="">
     <div class="wai">
   <div class="nei">
    <div class="jsl" v-show="classList1.length==0" >今天活动已经结束了，请您明天再来</div>
       <van-tabs  line-height='0' :ellipsis='false' title-active-color='red'  v-model="active">
  
  <van-tab  v-for="v in classList1" :key="v.ktime" title=""  >
      <template   #title> <p style="font-size:0.4rem" >{{v.ktime+':00'}}</p> <p style="font-size:0.3rem" >{{v.txt}}</p> </template>

      <div class="content">
        <ul>
          <li
            class="clearfix"
            v-for="v1 in v.list "
            :key="v1.id"
            @click="goi(v1.id,v1.start_date_h,v1.shengyunum,v1.ddt_isorsuperbuy)"
          
          >
          
          <div class="con">
            <img
              :src="v1.thumb"
              alt=""
            >
            <p class="name">{{v1.name}}</p>
            <!-- <p class="price">￥{{v.min_price}}</p> -->
            <div class="num">
                   <p class="num1">已买{{Number(v1.stock)- Number(v1.shengyunum) +v1.unit}}</p>
            <p class="num2">还剩{{v1.shengyunum+v1.unit}}</p>
            </div>

            <div class="progress">
                <van-progress track-color='#f8a4a4' style="" pivot-text='' color="#ee0a24"  :percentage="((v1.stock-v1.shengyunum)/v1.stock*100).toFixed(1)" stroke-width="8"/>
             
            </div>
            <div class="jg"><span style="position: relative;top: -0.1rem; font-size: 0.55rem;">{{ Number(v1.min_price) }}</span> 
              <div class="name2">{{Number(v1.superdeleteprice)  }}</div>
              </div>
          </div>
           
          </li>
         
        </ul>
      </div>
      
  </van-tab>
</van-tabs>
   </div>
   </div> 
     <div class="wai" 
     v-for=" (vv,i) in classList1"
         :key="i"
         v-show="i!=active"
    >
   <div class="nei">
       <van-tabs  line-height='0' :ellipsis='false' title-active-color='red' >
  
  <van-tab >
     
      <template   #title> <p style="font-size:0.4rem" >{{classList1[i].ktime+':00 场'}}</p>  </template>

      <div class="content">
        <ul>
          <li
            class="clearfix"
            v-for="v1 in classList1[i].list "
            :key="v1.id"
            @click="goi(v1.id,v1.start_date_h,v1.shengyunum,v1.ddt_isorsuperbuy)"
            

          >
          
          <div class="con">
            <img
              :src="v1.thumb"
              alt=""
            >
            <p class="name">{{v1.name}}</p>
            <div class="num">
                   <p class="num1">已买{{Number(v1.stock)- Number(v1.shengyunum) +v1.unit}}</p>
            <p class="num2">还剩{{v1.shengyunum+v1.unit}}</p>
            </div>

            <div class="progress">
                <van-progress track-color='#f8a4a4' style="" pivot-text='' color="#ee0a24"  :percentage="((v1.stock-v1.shengyunum)/v1.stock*100).toFixed(1)" stroke-width="8"/>
             
            </div>
           <div class="jg"><span style="position: relative;top: -0.5rem;">{{ Number(v1.min_price) }}</span> 
            <div class="name2">{{Number(v1.superdeleteprice)  }}</div>
          </div>
          </div>
           
          </li>
         
        </ul>
      </div>
      
  </van-tab>
</van-tabs>
   </div>
   </div> 
     
     <div class="dy">
  
     </div>
     <div class="" style="position: relative;">
      <img src="../../../assets/jvip/09.jpg" alt="">
  <div @click="govip" class="" style="width: 80%; height: 5rem;position: absolute;top: 2.6rem;left: 10%;"></div>
    </div>
      
      
     
      <div class="" style="height:0.5rem" ></div>
    <div class="dao" v-show="false">
      <van-count-down @finish='wanc' millisecond :time="time" format="HH:mm:ss:SS" />
    </div>
    </div>
  </template>
  <script>
  import Vue from 'vue'
  import {progress, Swipe, SwipeItem, Lazyload, NoticeBar, Grid, GridItem, Popup, Button, Toast ,CountDown, Tab, Tabs,Dialog, Search  } from 'vant'
  
  Vue.use(Swipe)
    .use(SwipeItem)
    .use(Lazyload, { lazyComponent: true })
    .use(NoticeBar)
    .use(Grid)
    .use(GridItem).use(Popup).use(Button).use(CountDown).use( Tab).use(Tabs ).use(Dialog).use(progress).use(Search)
  
  export default {
    name: 'board',
    created () {
         if (JSON.parse(localStorage.getItem('user')).id != 0) {
        this.login = 1
      } else {
      }
      if ([16, 17, 23].indexOf(this.$store.state.shopid) == -1) {
        this.jf = true
      } else {
        this.jf = false
      }
     // 'John'
          console.log(this.$route.query.pushts)
      if (this.$route.query.pushts) {
        this.$store.state.shopid=this.$store.state.shopid? this.$store.state.shopid:this.$route.query.pushts
     }
      // this.axios.post('userInfo', { store_id: this.$store.state.shopid, }).then(res => {               
      //       localStorage.setItem('vip', JSON.stringify({ id: res.data.info.super_vip }))
      //       localStorage.setItem('user-level', JSON.stringify({ id: res.data.info.level }))
      //      this.vip=res.data.info.super_vip
      //   }).catch(ref => { })
      this.vip1=JSON.parse(localStorage.getItem('vip')).id
      this.xtime=new Date().getHours()
      this.axios
          .get('ddtPrice', {
            params: {
              // this.$store.state.shopid
              ddt_price_isorsuperbuy : 1,
              store_id: this.$store.state.shopid,
            },
          }).then(res=>{
            // console.log(new Date())
            res.data.data.forEach(v => {
              v.time = v.end_time * 1000 - (Date.parse(new Date()))
            })
           let ks = new Date().getTime()-8200000
            console.log(ks)
            res.data.data.forEach(v1 => {
            if (v1.time > 0) {
              if (Number(v1.start_time)  * 1000 < ks ) {
               this.list.push(v1)
                
              }else if (ks - Number(v1.start_time) > 24 * 3600000) {
                 this.list.push(v1)
                 
                }
              }
            //   this.list.push(v1)
             
           });

            // this.list=res.data.data 
            this.cl()
          }).catch(ref=>{})
            
    },
    data () {
      return {
        value: '',
        show: false,
        images: [1, 2],
        searchBarFixed: false,
        navSwitch: 1,
        number: -1,
        str: '',
        ad: [],
        list:[],
        classList: [{id:'1',stime:'14',time:'1702310400000',etime:'18',name:'sda1'},{stime:'14',time:'1702396800000',etime:'16',id:'2',name:'sda2'},{id:'3',stime:'16',time:'1702310400000',etime:'18',name:'sda3'},],
        classList1: [],
        screenType: 'zonghe',
        productList: [],
        isEnd1: true,
        deswiper: '',
        login: sessionStorage.getItem('login'),
        isEnd: false, //判断是否为最后一页
        params: {
          page: 1,
          id: '',
          sort_field: 'sort',
          class_three: '',
          sort_type: '',
        },
        screenState: 1,
        totalHeight: 0,
        vip1:0,
        statusNav: 1,
        id: 157,
        fg:false,
        time:0,
        active:0,
        gs:0,
        xtime:0
      }
    },
    props: {
    },
    computed: {
  
    },
    watch: {
  
    },
   
    mounted () {
  
    },
    methods: {
      gos () {
        this.$router.push("/")
      },
     
      getClientHeight () {
  
      },
     goi(id,s,num,vip){
         if(vip==1){
          if(this.vip1==0){
                Dialog.confirm({   title: '',
     message: '此活动只限鲸会员用户购买',
     confirmButtonText : '开通鲸会员',
    confirmButtonColor:'red', })
    .then(() => {
      this.$router.push('opvip2')
     })
    .catch(() => {
      // on cancel
     })
            return
          }
       
       }
       
  if(num<=0){
    Toast('今日商品已售罄，明天10点准时开抢')
    return false
  }
  // if (new Date() > s * 1000) { 
  //        Toast('每天10点开始抢购哦~')
  //       return false
  //      }
       let t = new Date().getHours()
      //  let t = 1
      
        if(t<10){
          Toast('每天10点开始抢购哦~')
  
          return
        }else{
        this.$router.push({ name: 'tianp', query: { id ,jian:1,jhy:1} })
  
        }
  
      },
      cl1(){
        Toast('商品正在筹备中~')
      },
  cl(){
    let arr=[]
    let arr1=[]
    let list1=[]
    this.list.forEach(v=>{   
        if(arr.indexOf(v.start_date_h)==-1){
          arr.push(v.start_date_h)       
            arr1.push({etime:v.end_date_h, ktime:v.start_date_h,txt:new Date().getHours()>= Number(v.start_date_h) ?'':''})
        } 
       
    })
      arr1.forEach(v1=>{
        list1=[]
        this.list.forEach(v2=>{
         if(v1.ktime==v2.start_date_h){
           if(new Date()>v2.start_date_ll*1000 ){
           list1.push(v2)
           }
         }
       })
        v1.list=list1
      }
    )
   
    // let arr2=[]
    arr1.forEach((v,i)=>{
      if(v.ktime<=this.xtime){
        if(this.xtime<v.etime){
        this.active=i
  
        }else{
        this.active=0
  
        }
      }else{
  
        // arr2.push(v)
      }
    })
    arr1.forEach(v => {
      v.list.sort(function(a,b){
        return a.sort-b.sort
      })
    })
    this.classList1=arr1
    // console.log(arr)
  },
      govip () {
      this.$router.push('opvip2')
    
  },
      enterDetail (goods) {
        return false
        this.$router.push({
          name: 'product',
          params: {
            id: goods.id,
            status: 1,
          },
        })
      },
      
     toList(){
  
     },
      getProductList () {
  
      },
      getClassList () {
  
      },
      wanc(){
          this.fg=false
      }
    },
  
    destroyed () { },
    updated () { },
    components: {},
  }
  </script>
  
  
  <style lang="less" scoped>
  .w1{
    // width: 80%;
    margin: 0 auto;
    padding-top: 0.4rem;
    // background-color: #640fb2;
  
  }
  .w2{
    padding:  0.2rem;
  }
  .mi {
    padding: 0.5rem;
    text-align: center;
  
    p {
      font-size: 0.5rem;
      margin: 0.5rem;
    }
    input {
      height: 1rem;
      width: 70%;
      border-radius: 5%;
      font-size: 0.4rem;
    }
    margin-bottom: 1rem;
  }
  .sks {
    width: 100%;
    z-index: 99;
    height: 1.45rem;
    background-color: #640fb2;
    text-align: center;
    // padding-left: 1rem;
    font-weight: 600;
    font-size: 0.4rem;
    line-height: 1.5rem;
    position: fixed;
    top: 0;
    left: 0;
    color: #fff;
    //   margin-top: 0.5rem;
    // position: fixed;
    // top: 0;
    // z-index: 99;
    // width: 100%;
    span {
      width: 1rem;
      position: absolute;
      left: 0;
      font-size: 0.5rem;
    }
  }
  .sp {
    width: 100%;
    height: 5.4rem;
    overflow: hidden;
  }
  .sp::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  .pad {
  //   height: 0.2rem;
  // position: relative;
  // bottom: 0.2rem;
  padding: 0.4rem 0.2rem 0 0.2rem;
  
  //   background-color: #640fb2;
  }
  
  
  
  .wgdb {
  
  padding: 0 0.2rem;
    // position: relative;
    // bottom: 1.8rem;
    .ws{
    z-index: 2;
  // border: 1px solid #f7f4ad;
  border-radius: 0.1rem;
      padding-top:0.5rem;
      // background-color: #fff;
      
      .wsn{
          float: left;
          width: 50%;
          padding: 1%;
          img{
              width: 100%;
          }
      }
    }
    .wgdb1{
      padding: 0.5rem 0.2rem;
      //  background-color: rgba(79, 77, 77, 0.324);
  padding-top: 1rem;
      }
      .more{
        text-align: center;
        font-size: 0.54rem;
        color: white;
        line-height: 2rem;
      }
  }
  
  
  
  .hot{
      //  position: relative;
          padding: 0.2rem;
  background-color: #fbf6fd;
          // bottom: 1rem;
          .sd{
              height: 0.2rem;
          }
      .top{
          // width: 30%;
          height: 1rem;
          img{
              width: 1.5rem;
              float: left;
          }
          p{
              color: #fff;
              font-size: 0.5rem;
              line-height: 0.6rem;
              padding-left: 1.7rem;
          }
      }
  }
  
  .dao{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #fff;
      z-index: 99;
  }
  .guod{
    position: relative;
    .dian{
      width: 100%;
      height: 5.2rem;
      // background-color: #ffa082;
      border-radius: 30% 30% 0 0;
      position: relative;
      bottom: 0.5rem ;
        // padding-top: 0.8rem;
  padding: 1.2rem 0.2rem;
      .dnei{
        background-color: #fff;
        border-radius: 0.3rem;
        height: 3.5rem;
        padding: 0.4rem 0rem 0rem 0.4rem;
        li{
          float: left;
          // margin: 0.1rem;p
          margin-right: 0.05rem;
          width: 24%;
          text-align: center;
          color: #5d5a5a;
          .p1{
            padding: 0.1rem;
            background-color: red;
            border-radius: 0.4rem;
            color: #fff;
  
          }
        }
      }
    }
  }
  .board {
    padding-top:1.1rem;
    // 轮播
    overflow-x: hidden;
    //   padding-top: 0.8rem;
    background-color: #640fb2;
    .mint-swipe {
      width: 100%;
      height: 3.28rem;
  
      .mint-swipe-items-wrap {
        width: 100%;
        height: 3.28rem;
  
        .mint-swipe-item {
          width: 100%;
          height: 3.28rem;
  
          .board-banner-img {
            width: 100%;
            height: 3.28rem;
            background-size: 100%;
          }
        }
      }
    }
    .flp {
      // background-color: #f8a4a4;
      padding: 0 0.2rem;
      padding-top: 0.2rem;
      position: relative;
      // bottom: 2rem;
        
    }
    .fenl {
      background: url(../../../assets/s11/ss/05.png) no-repeat center;
     background-size: 100% 100%;
      // margin: 0 0.2rem;
      p {
        height: 0.75rem;
        line-height: 0.5rem;
        font-weight: 700;
        font-size: 0.3rem;
      }
      // background: #fff;
      padding: 0 0.3rem;
      padding-top: 1.2rem;
      text-align: center;
      box-sizing: border-box;
  
      .fenl_1 {
        width: 16.5%;
        text-align: center;
        float: left;
        margin-bottom: 0.45rem;
  
        img {
          width: 1.2rem;
          // height: 1.5rem;
          border-radius: 5px;
          margin: 0 auto;
        }
  
        div {
          color: #333;
          font-size: 0.22rem;
          margin-top: 0.12rem;
        }
      }
    }
  .sz{
      // display: flex;
      position: relative;
      // bottom: 1.5rem;
  padding: 0 0.2rem;
  padding-top: 1rem;
  z-index: 22;
      .szn{
          float: left;
          width: 33.3%;
          margin: 0 auto;
         
      }
  }
    .mt {
      margin-top: 10px;
    }
  
    .scrolltop {
      position: fixed;
      width: 100%;
      top: 0;
      z-index: 1000;
      margin-top: 0;
    }
  
    .board_imglist {
      background: #fff;
      margin-top: 1px;
      padding: 0.21rem;
      padding-top: 0.26rem;
      padding-bottom: 0.45rem;
  
      .board_img:nth-child(odd) {
        float: left;
        width: 48.5%;
      }
  
      .board_img:nth-child(even) {
        float: right;
        width: 48.5%;
      }
  
      .board_img {
        height: 5rem;
  
        .title {
          height: 0.6rem;
        }
  
        div:first-child {
          img {
            width: 100%;
            height: 3.2rem;
          }
        }
  
        div:nth-child(2) {
          margin-top: 0.16rem;
  
          span.sp1 {
            color: #a22d2b;
            font-size: 0.26rem;
            border: 1px solid #a22d2b;
            padding: 0.02rem 0.05rem;
            border-radius: 0.05rem;
          }
  
          span.sp2 {
            color: #333;
            font-size: 0.26rem;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            width: 100%;
          }
        }
  
        div:last-child {
          margin-top: 0.16rem;
  
          span:first-child {
            color: #a22d2b;
            font-size: 0.26rem;
          }
  
          /*span:last-child {*/
          /*line-height: 0.2rem;*/
          /*color: #999;*/
          /*font-size: .26rem;*/
          /*text-decoration: line-through*/
          /*}*/
        }
      }
    }
  }
  .wai{
      padding: 0.2rem;
        position: relative;
      bottom: 0.5rem ;
      // background-color: #ffa082;
      
  }
  .nei{
      // padding: 0.2rem;
      background-color: #fff;
      border-radius: 0.3rem;
      overflow: hidden;
       .pt1{
          font-size: 0.43rem;
      }
      .pt2{
          font-size: 0.3rem;
      }
      .jsl{
        text-align: center;
        // line-height: 1.5rem;
        padding-top: 0.2rem;
        color: #474646;
        font-size: 0.45rem;
      }
  }
  .content {
      flex: 1;
      background-color: #fff;
      .title {
        text-align: center;
        font-size: 0.4rem;
        height: 1rem;
      }
      ul {
        li {
          // float: left;
          // width: 45%;
          // padding: 0.266667rem 0.01rem 0.1rem 0.533333rem;
          // padding-left: 0.1rem;
          // padding-right: 0.1rem;
          // margin-left: 0.1rem;
          margin: 0.2rem 0 1.2rem 0.2rem;
         position: relative;
  
          .con{
          // background-color: rgb(238, 236, 236);
          height: 3.2rem;
  
          }
          img {
            width: 3.2rem;
            float: left;
            margin-right: 0.2rem;
          }
          .price {
            height: 0.9rem;
            line-height: 0.9rem;
            font-size: 0.4rem;
            color: #a22d2b;
          }
          .name {
            font-size: 0.373333rem;
              padding-top: 0.2rem;
          font-weight: 600;
            color: #333;
            display: -webkit-box;
    -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
  
          }
          .progress{
              // overflow: hidden;
              padding-top: 0.52rem;
             margin-left: 3.5rem;
              width: 35%;
          }
          .num{
              // float: right;
              position: absolute;
              // height: 2rem;
              right: 0.5rem;
              top: 30%;
              text-align: right;
              padding-right: 0.2rem;
              
              // line-height: -2rem;
          }
          .jg{
             width: 5.3rem;
             height: 1.25rem;
            margin-left: 3.4rem;
                 margin-top: 0.55rem;
     // text-align: center;
 padding-left: 2rem;
 font-size: 0.65rem;
 font-weight: 700;
 line-height: 1.8rem;
 color: red;
             background: url(../../../assets/you/02.png) no-repeat center;
    background-size: 95% 100%;
    position: relative;
         }
         .name2 {
            position: absolute;
            top: -0.32rem;
            left: 0.32rem;
           font-size: 0.36rem;
           color: #333;
          padding: 0.1rem;
          padding-top: 0.2rem;
         }
           .name3 {
            font-size: 0.373333rem;
            color: rgb(241, 49, 49);
           padding: 0.1rem;
          //  padding-top: 0.2rem;
          }
        }
      }
    }
    .dy{
      // background-color: #f6f6f6;
      // height: 1rem;
      position: relative;
      bottom: 0.5rem;
      border-radius: 0 0 50% 50%;
    }
    .tianjia{
      padding-top: 0.5rem;
      height: 3.5rem;
      background-color: #f6f6f6;
      text-align: center;
  
      img{
        width: 80%;
        height: 2.8rem;
        margin: 0 auto;
      }
    }
    .tianjia1{
      background-color: #f6f6f6;
  
    }
  </style>
  